import React from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Shimmer } from "sprint-common-web";

import { PageHeader } from "../../../../common/ui/layout/header/PageHeader";
import { ciFileRecordsRoute, getCiFileRecordQcReviewPageHref } from "../../../ContentIngestionRoutes";
import { RemoveFileRecordDetailsButton } from "../buttons/remove/RemoveFileRecordDetailsButton";
import { useFileRecordDetailsState } from "../hooks/useFileRecordDetailsState";

export const FileRecordDetailsPageHeader = (): JSX.Element => {
    const { fileRecordDetails } = useFileRecordDetailsState();

    const { url, params } = useRouteMatch<{ fileRecordId: string }>();

    const isEditContent = isEditContentUrl(url);

    const history = useHistory();

    const goToFileRecordListing = () => history.push(ciFileRecordsRoute.path);

    const goToFileRecordDetails = () => {
        const path = getCiFileRecordQcReviewPageHref(params.fileRecordId);
        history.push(path);
    };

    const handleDeliveryFileNameClick = () => {
        if (isEditContent) {
            goToFileRecordDetails();
        }
    };

    const items: BreadcrumbItem[] = [
        {
            key: "content-ingestion-breadcrumb",
            text: "Content ingestion"
        },
        {
            key: "file-records-breadcrumb",
            text: "File Records",
            onClick: () => goToFileRecordListing()
        },
        {
            key: "delivery-file-name-breadcrumb",
            text: fileRecordDetails.deliveryFileName,
            onClick: () => handleDeliveryFileNameClick()
        }
    ];

    if (isEditContent) {
        items.push({
            key: "edit-content-breadcrumb",
            text: "Edit content"
        });
    }

    return fileRecordDetails.deliveryFileName ? (
        <PageHeader>
            <Breadcrumb items={items} />
            {!isEditContent && <RemoveFileRecordDetailsButton itemId={params.fileRecordId} />}
        </PageHeader>
    ) : (
        <PageHeader>
            <Shimmer width="60%" />
        </PageHeader>
    );
};

const isEditContentUrl = (url: string) => {
    return url.includes("edit-content");
};
